// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__HIAv7","title":"ClientReferral_title__3NnSX","itemText":"ClientReferral_itemText__17lxu"};